import { useEffect } from 'react';
import { useGetUserMeQuery } from '../../../../services/entities/impl/blfApi/endpoints/users';

/**
 * Identify the current user by email using Heap analytics.
 */
const useHeapAnalytics = () => {
  const { data: currUser } = useGetUserMeQuery();

  useEffect(() => {
    // Function to identify the user in Heap analytics
    const identifyUser = () => {
      if ('heap' in window) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const heap = window.heap as any;
        if ('identify' in heap && currUser?.email) {
          // Using Heap's API to identify the user by their email
          heap.identify(currUser.email);
          console.log(`Heap Analytics User: ${currUser.email}`);
        } else if (!window.heap) {
          console.error('Heap Analytics is not loaded yet.');
        }
      }
    };

    identifyUser();
  }, [currUser]);
};

export default useHeapAnalytics;
